export const FETCH_LOCATION_CATEGORIES =
  "experiencesSearch/FETCH_LOCATION_CATEGORIES";
export type FETCH_LOCATION_CATEGORIES = typeof FETCH_LOCATION_CATEGORIES;

export const SET_LOCATION_CATEGORIES =
  "experiencesSearch/SET_LOCATION_CATEGORIES";
export type SET_LOCATION_CATEGORIES = typeof SET_LOCATION_CATEGORIES;

export const SET_LOCATION = "experiencesSearch/SET_LOCATION";
export type SET_LOCATION = typeof SET_LOCATION;

export const SET_LOCATION_AUTOCOMPLETE_ERROR =
  "experiencesSearch/SET_LOCATION_AUTOCOMPLETE_ERROR";
export type SET_LOCATION_AUTOCOMPLETE_ERROR =
  typeof SET_LOCATION_AUTOCOMPLETE_ERROR;

export const SET_FROM_DATE = "experiencesSearch/SET_FROM_DATE";
export type SET_FROM_DATE = typeof SET_FROM_DATE;

export const SET_UNTIL_DATE = "experiencesSearch/SET_UNTIL_DATE";
export type SET_UNTIL_DATE = typeof SET_UNTIL_DATE;

export const SET_CATEGORY_TAG_ID = "experiencesSearch/SET_CATEGORY_TAG_ID";
export type SET_CATEGORY_TAG_ID = typeof SET_CATEGORY_TAG_ID;

export const SET_ENTRY_TYPE = "experiencesSearch/SET_ENTRY_TYPE";
export type SET_ENTRY_TYPE = typeof SET_ENTRY_TYPE;

export const SET_ENTRY_TYPES_ALL = "experiencesSearch/SET_ENTRY_TYPES_ALL";
export type SET_ENTRY_TYPES_ALL = typeof SET_ENTRY_TYPES_ALL;

export const SET_LODGING_ID = "experiencesSearch/SET_LODGING_ID";
export type SET_LODGING_ID = typeof SET_LODGING_ID;

export const SET_STAYS_ADVANCE = "experiencesSearch/SET_STAYS_ADVANCE";
export type SET_STAYS_ADVANCE = typeof SET_STAYS_ADVANCE;

// Trip destinations action types
export const FETCH_TRIP_DESTINATIONS =
  "experiencesSearch/FETCH_TRIP_DESTINATIONS";
export type FETCH_TRIP_DESTINATIONS = typeof FETCH_TRIP_DESTINATIONS;

export const SET_TRIP_DESTINATIONS =
  "experiencesSearch/SET_TRIP_DESTINATIONS";
export type SET_TRIP_DESTINATIONS = typeof SET_TRIP_DESTINATIONS;

export const SET_TRIP_DESTINATIONS_LOADING =
  "experiencesSearch/SET_TRIP_DESTINATIONS_LOADING";
export type SET_TRIP_DESTINATIONS_LOADING = typeof SET_TRIP_DESTINATIONS_LOADING;

export const SET_TRIP_DESTINATIONS_ERROR =
  "experiencesSearch/SET_TRIP_DESTINATIONS_ERROR";
export type SET_TRIP_DESTINATIONS_ERROR = typeof SET_TRIP_DESTINATIONS_ERROR;

export const SET_TRIP_DESTINATIONS_LOADED =
  "experiencesSearch/SET_TRIP_DESTINATIONS_LOADED";
export type SET_TRIP_DESTINATIONS_LOADED = typeof SET_TRIP_DESTINATIONS_LOADED;

// Combined autocomplete action types
export const FETCH_COMBINED_AUTOCOMPLETE =
  "experiencesSearch/FETCH_COMBINED_AUTOCOMPLETE";
export type FETCH_COMBINED_AUTOCOMPLETE = typeof FETCH_COMBINED_AUTOCOMPLETE;

export const SET_COMBINED_AUTOCOMPLETE_RESULTS =
  "experiencesSearch/SET_COMBINED_AUTOCOMPLETE_RESULTS";
export type SET_COMBINED_AUTOCOMPLETE_RESULTS =
  typeof SET_COMBINED_AUTOCOMPLETE_RESULTS;

export const SET_COMBINED_AUTOCOMPLETE_ERROR =
  "experiencesSearch/SET_COMBINED_AUTOCOMPLETE_ERROR";
export type SET_COMBINED_AUTOCOMPLETE_ERROR =
  typeof SET_COMBINED_AUTOCOMPLETE_ERROR;

export const CLEAR_COMBINED_AUTOCOMPLETE =
  "experiencesSearch/CLEAR_COMBINED_AUTOCOMPLETE";
export type CLEAR_COMBINED_AUTOCOMPLETE = typeof CLEAR_COMBINED_AUTOCOMPLETE;
